var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyinfo04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 15.227",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_43",
    "data-name": "Union 43",
    fill: "#002a57",
    d: "M1.747,15.227A1.749,1.749,0,0,1,0,13.48V1.747A1.749,1.749,0,0,1,1.747,0H18.253A1.749,1.749,0,0,1,20,1.747V13.48a1.749,1.749,0,0,1-1.747,1.747ZM1.333,1.747V13.48a.419.419,0,0,0,.414.413H18.253a.419.419,0,0,0,.413-.413V1.747a.419.419,0,0,0-.413-.414H1.747A.42.42,0,0,0,1.333,1.747ZM13.333,12a.666.666,0,0,1,0-1.333h4a.666.666,0,1,1,0,1.333ZM10,11.614H3.334a.667.667,0,0,1-.667-.667,3.713,3.713,0,0,1,.375-1.753A3.882,3.882,0,0,1,5.586,7.257c-.057-.032-.117-.066-.181-.1a2,2,0,1,1,2.521,0,.775.775,0,0,0-.07.095A3.328,3.328,0,0,1,8.73,7.6a4.847,4.847,0,0,1,1.937,3.227.689.689,0,0,1,.014.122.667.667,0,0,1-.667.667ZM4.084,10.28H9.249a2.667,2.667,0,0,0-5.165,0ZM6,5.613a.666.666,0,1,0,.666-.667A.667.667,0,0,0,6,5.613Zm7.332,3.72a.666.666,0,0,1,0-1.333h4a.666.666,0,1,1,0,1.333Zm0-2.667a.666.666,0,0,1,0-1.333h4a.666.666,0,1,1,0,1.333Zm0-2.666a.667.667,0,0,1,0-1.334h4a.667.667,0,0,1,0,1.334Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyinfo04);
export default __webpack_public_path__ + "static/media/myinfo-04.72e85532821cdda5fbaff838416b2e87.svg";
export { ForwardRef as ReactComponent };